import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MainService } from './main.service';
import { TokenService } from 'src/app/token.service';

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  httpUrl;


  constructor(private http: HttpClient, private main: MainService, private token: TokenService) {
    this.httpUrl = this.main.httpUrl + "/hr/setting";
  }
  //fields
  async getFields(obj: any) {

    const res = await this.http.get<any>(this.main.httpUrl + '/metadata/fields/getfields' + obj, { headers: new HttpHeaders().append('token', this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;

    });
    return res;

  }
  async createFields(obj: any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/metadata/fields/createField', obj, { headers: new HttpHeaders().append('token', this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateFields(obj: any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/metadata/fields/updateField', obj, { headers: new HttpHeaders().append('token', this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  //codeValue
  async getCodeValue(b_acct_id: any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/metadata/codeValue/getCodeValues' + b_acct_id, { headers: new HttpHeaders().append('token', this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getFieldCodeValues(obj: any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/metadata/codeValue/getFieldCodeValues' + JSON.stringify(obj), { headers: new HttpHeaders().append('token', this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async insertCodeValue(obj: any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/metadata/codeValue/createCodeValue', obj, { headers: new HttpHeaders().append('token', this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateCodeValues(obj: any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/metadata/codeValue/updateCodeValue', obj, { headers: new HttpHeaders().append('token', this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteCodeValue(obj: any) {
    const resp = await this.http.delete<any>(this.main.httpUrl + '/metadata/codeValue/deleteCodeValue' + obj, { headers: new HttpHeaders().append('token', this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

}
